import React from 'react';
import { Link } from 'react-router-dom';
import { products, artworks } from '../../data/products';
import './FeaturedCollection.css';

// Vinyl & Rose, Canvas & Cedar, one artwork, Lavender Reverie body butter
const featured = [
  { ...products[0], category: 'fragrance' as const },
  { ...products[1], category: 'fragrance' as const },
  {
    id: artworks[0].id,
    handle: artworks[0].handle,
    title: artworks[0].title,
    subtitle: artworks[0].story || '',
    price: artworks[0].price,
    category: 'art' as const,
    type: artworks[0].type,
    images: artworks[0].images,
    scentFamily: undefined as undefined,
  },
  { ...products[2], category: 'body' as const }, // Lavender Reverie body butter
];

const FeaturedCollection: React.FC = () => (
  <section className="featured-collection" aria-label="Featured collection">
    <div className="featured-collection__inner container">
      <div className="featured-collection__header">
        <h2 className="featured-collection__title">Featured Works</h2>
        <Link to="/fragrance" className="featured-collection__view-all">
          View All →
        </Link>
      </div>

      <div className="featured-collection__grid">
        {featured.map((item) => {
          const href =
            item.category === 'art'
              ? `/art/${item.handle}`
              : `/${item.category}/${item.handle}`;

          return (
            <Link key={item.id} to={href} className="featured-card">
              <div className="featured-card__image-wrap">
                <img
                  src={item.images[0]}
                  alt={item.title}
                  className="featured-card__image"
                  width={400}
                  height={500}
                  loading="lazy"
                />
              </div>
              <div className="featured-card__info">
                <span className="featured-card__type">{item.type}</span>
                <h3 className="featured-card__title">{item.title}</h3>
                <span className="featured-card__price">{item.price}</span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default FeaturedCollection;
